const initialState = {
	list: [],
	page: 1,
	isListNext: false,
	datetime: null,
	scrollpos: 0,
};

export default function reducer(state = initialState, action) {
	if (action.type === 'COMMUNITY_QA_LIST_SET') {
		let newState = Object.assign({}, state);
		newState.list = action.payload.list;
		newState.page = action.payload.page;
		newState.isListNext = action.payload.isListNext;
		newState.datetime = (new Date());
		return newState;
	}
	else if (action.type === 'COMMUNITY_QA_ITEM_SET') {
		let newState = Object.assign({}, state);
		if (action.payload.type === 'del') {
			let list = newState.list.filter((value) => (value.userdata_id_code !== action.payload.pic));
			newState.list = list;
		}
		return newState;
	}
	else if (action.type === 'COMMUNITY_QA_ANSWER_SET') {
		let newState = Object.assign({}, state);
		let index = newState.list.findIndex((v) => v.qa_id === action.payload.qaId);

		if (index >= 0) {
			newState.list[index]['qa_my_answer'] = action.payload.answerText;
			if (action.payload.answerText === null) {
				delete newState.list[index]['statistics'];
			}
		}

		return newState;
	}
	else if (action.type === 'COMMUNITY_QA_STATISTICS_SET') {
		let newState = Object.assign({}, state);
		let index = newState.list.findIndex((v) => v.qa_id === action.payload.qaId);

		if (index >= 0) {
			if (action.payload.type === 'add') {
				newState.list[index]['statistics'] = action.payload.statistics;
			}
			else if (action.payload.type === 'del') {
				delete newState.list[index]['statistics'];
			}
		}
		return newState;
	}
	else if (action.type === 'COMMUNITY_QA_STATISTICS_USER_SET') {
		let newState = Object.assign({}, state);
		let listIndex = newState.list.findIndex((v) => v.qa_id === action.payload.qaId);

		if (listIndex >= 0) {
			let statisticsIndex = newState.list[listIndex]['statistics'].findIndex((v) => v.answer_comment === action.payload.answerText);
			if (statisticsIndex >= 0) {
				if (action.payload.type === 'add') {
					newState.list[listIndex]['statistics'][statisticsIndex]['user'] = {
						list: action.payload.list,
						isListNext: action.payload.isListNext,
						page: action.payload.page,
					};
				}
				else if (action.payload.type === 'del') {
					delete newState.list[listIndex]['statistics'][statisticsIndex]['user'];
				}
			}
		}
		return newState;
	}
	else if (action.type === 'COMMUNITY_QA_SCROLLPOS_SET') {
		let newState = Object.assign({}, state);
		newState.scrollpos = action.payload.scrollpos;
		return newState;
	}
	else {
		return state;
	}
}
